import './Experience.css'
import uniqid from 'uniqid'

const Experience = ({ experiences }) => {
  // If no data → render nothing
  if (!Array.isArray(experiences) || experiences.length === 0) return null

  return (
    <section className='section experience' aria-labelledby='experience-title'>
      <h2 id='experience-title' className='section__title'>
        My journey
      </h2>

      <div className='timeline' role='list'>
        {experiences.map((exp) => (
          <div key={uniqid()} className='timeline__item' role='listitem'>
            <span className='timeline__marker' aria-hidden='true' />
            <span className='timeline__line' aria-hidden='true' />

            <article className='timeline__content'>
              <header className='timeline__header'>
                <h3 className='timeline__title'>
                  {exp.logo && (
                    <img
                      src={exp.logo}
                      alt=''
                      className='timeline__logo'
                    />
                  )}
                  {exp.title || ''}
                </h3>

                <div className='timeline__meta'>
                  {exp.organization && (
                    <strong className='timeline__org'>
                      {exp.organization}
                    </strong>
                  )}

                  {exp.duration && (
                    <time className='timeline__duration'>
                      {exp.duration}
                    </time>
                  )}
                </div>
              </header>

              {Array.isArray(exp.keyPoints) && exp.keyPoints.length > 0 && (
                <ul className='timeline__bullets'>
                  {exp.keyPoints.map((point) => (
                    <li key={uniqid()}>{point}</li>
                  ))}
                </ul>
              )}
            </article>
          </div>
        ))}
      </div>
    </section>
  )
}

export default Experience